import "./IconBadge.scss";
import { ReactComponent as BadgeIcon } from "./svg/icon_badge.svg";

export const IconBadge = ({
  width = "auto",
  height = "auto",
  color = "default",
}: {
  width?: string;
  height?: string;
  color?: "default" | "blue";
}) => {
  const className = `icon-badge__${color}`;

  return (
    <div className={className} style={{ width, height }}>
      <BadgeIcon />
    </div>
  );
};
